import medicalInterior1 from './medical-interior-1.jpg';

const LandingBanner = (): JSX.Element => (
    <img alt="Futuristic looking medical equipment" src={medicalInterior1} />
);

export default LandingBanner;